import { LabelType } from './label-types.enum';
import {
    locationIdentifiersKey,
    SlotDto,
    zoneAndSlotBarcodesFromSlotBarcode,
} from '@pf/platform-wms/domain';
import { ItemDto } from '@pf/platform-item-catalog/domain';

export const LabelTemplates = {
    [LabelType.Slot]: (slot: SlotDto) => {
        const equipmentTypeText = slot.equipmentType?.name
            ? `(${slot.equipmentType.name})`
            : '';
        const zoneIdentifierText = slot.zone
            ? locationIdentifiersKey(slot.zone.locationIdentifiers)
            : zoneAndSlotBarcodesFromSlotBarcode(slot.barcode);
        const barcodeText = slot.barcode ?? '';
        const slotTypeText = slot.slotType ?? '';

        return `
^XA
^CI28
^PW609
^LL203

^CF0,28
^FO20,15^FDSlot ${equipmentTypeText}^FS
^FO20,50^FDZone ${zoneIdentifierText}^FS

^CF0,22
^FO20,85^FD${slotTypeText}^FS

^CF0,28
^FO20,150^FD${barcodeText}^FS

^FO430,20^BQN,2,7
^FDQA,${barcodeText}^FS

^XZ`.trim();
    },
    [LabelType.HandlingUnit]: (barcode: string, type: string) => {
        return `
^XA
^CI28

^CF0,40
^FO50,50^FDHandling Unit^FS
^FO50,140^FD${type} ${barcode}^FS

^FO460,40^BQN,2,14
^FDQA,${barcode}^FS

^XZ
`.trim();
    },
    [LabelType.Item]: (item: ItemDto) => {
        const barcode = item.sku || item.code || '';
        return `
^XA
^CI28

^FO50,40^A0N,28,28^FB450,3,0,L^FD${item.name || ''}^FS

^FO50,130^A0N,22,22^FB450,6,0,L^FD${item.description || ''}^FS

^FO530,240^A0N,30,30^FD${barcode}^FS

^FO520,40^BQN,2,8^FD${barcode}^FS

^XZ
        `.trim();
    },
};
